'use client'

import { useTranslation } from '@shared/config/i18n'
import { UI_IDS } from '@shared/constants'
import { clsx } from 'clsx'
import Image from 'next/image'

import { ButtonV1, Typography } from '@podo-app/design-system-temp'

type ButtonProps = Parameters<typeof ButtonV1>[0]

type Props = {
  className?: string
} & ButtonProps

const KakaoLoginButton = ({ className, ...props }: Props) => {
  const t = useTranslation()

  return (
    <ButtonV1
      size="xLarge"
      className={clsx(
        'kakao_login_btn',
        `py-2.5 text-gray-900 rounded-[7.5px] flex items-center justify-center gap-[5px] w-full bg-[#F9E000] hover:bg-[#FFF7AD]`,
        className,
      )}
      eventParams={{ name: UI_IDS.btn.kakaoLogin, location: 'login', action: 'submit' }}
      {...props}
    >
      <Image src="/images/login_icon_kakao.png" alt="login_icon_kakao" width={24} height={24} />
      <Typography size="h3">{t('common.auth.kakaoFastLogin')}</Typography>
    </ButtonV1>
  )
}

export default KakaoLoginButton
